/* global mousemoveLazyLoad */
import { showCalendarModalForUS } from './utility';
import { getIPAddress } from './utils/analytics';

// Retriving parameters from URL for the passed param
// todo: @rohan this can be written in more generic manner
const getUrlParameter = (param) => {
  const currentUrlVariables = window.location.search.substring(1).split('&');
  for (const urlValues of currentUrlVariables) {
    const parameterName = urlValues.split('=');
    if (parameterName.length > 0 && parameterName[0] === param) {
      return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
    }
  }
};

/* Debouncing is a programming practice used to ensure that time-consuming tasks do not fire so often,
  that it stalls the performance of the web page. It limits the rate at which a function gets invoked. */
const debounce = (func, delay) => {
  let debounceTimer;
  return (...args) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func(...args), delay);
  };
};

// lazy loading iframes (Select all iframes with the class "lazy-iframe")
const lazyIframes = document.querySelectorAll('iframe.lazy-iframe');

// Create an Intersection Observer instance
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const iframe = entry.target;
      const src = iframe.getAttribute('data-src');
      if (src) {
        iframe.setAttribute('src', src);
        observer.unobserve(iframe); // Stop observing once iframe is loaded
      }
    }
  });
});

// Start observing each lazy iframe
lazyIframes.forEach((iframe) => {
  observer.observe(iframe);
});

const loadImagesOnMouseMovement = () => {
  const loadAllImages = () => {
    if (typeof mousemoveLazyLoad !== 'undefined') {
      mousemoveLazyLoad.loadAll();
    }
  };

  document.addEventListener('touchstart', loadAllImages, {
    once: true,
    passive: true
  });
  document.addEventListener('mousemove', loadAllImages, {
    once: true
  });
};

const downloadPdfFile = (filename, fileurl) => {
  const userAgent = window.navigator.userAgent;
  const trident = userAgent.indexOf('Trident/');
  if (trident > -1) {
    window.location.href = fileurl;
  } else {
    const link = document.createElement('a');
    link.href = fileurl;
    link.download = filename;
    link.setAttribute('target', '_blank');
    link.click();
  }
};

// smooth scroll to the targeted div
const smoothScroll = (scrollTodiv, topPadding) => {
  const targetElement = document.querySelector(`.${scrollTodiv}`);
  if (targetElement) {
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - topPadding;
    
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
};

// Get the IP information - used for adding workflow in HS for Sales team: related to HS calendar scheduler
const ipInfo = getIPAddress();
if (ipInfo && ipInfo.country) {
  // Set the value of the hidden input field to ipInfo.country (default value will be United States, set from HTML)
  const el = document.getElementById('ip-country-updated');
  if (el) {
    el.value = ipInfo.country;
  }
  
  // Setup US-specific calendar modal functionality
  const usCalendarModalHandler = showCalendarModalForUS(ipInfo);
  if (usCalendarModalHandler) {
    // Store the handler globally for use in other parts of the application
    window.showUSCalendarModal = usCalendarModalHandler;
  }
}

window.smoothScroll = smoothScroll;

export {
  getUrlParameter,
  debounce,
  loadImagesOnMouseMovement,
  downloadPdfFile,
  smoothScroll,
};